import { UpsellGuard } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'
import { FontSelect } from '@features/invoicingSettings/modules/logoAndBranding'

import { Scope } from '../../../../../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../../../../../enums/trackingContext'
import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultFont = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      name="templateFont"
      label={t('settings.organization.external_invoice.appearance.default_font.label')}
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <UpsellGuard scope={Scope.InvoiceDesignerUpsell} trackingContext={TrackingContext.InvoiceDesigner}>
            <FontSelect
              {...props}
              defaultSelectedId={value}
              dropdownSize="fitTrigger"
              onSelect={(id?: string) => {
                onChange?.(id)
                trackInvoicingSettings('Font selected', { font: id })
              }}
              selectedId={value}
            />
          </UpsellGuard>
        )
      }}
    />
  )
}
